'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import Actions from 'AdsUI/lib/Actions';
import { List } from 'immutable';
import AdCreationRecord, { LeadAdAutomateRecord } from 'AdsUI/records/ad-management/AdCreationRecord';
import { CREATIVE_RECORD_BY_TYPE } from 'AdsUI/records/ad-management/AdCreationCreativeRecord';
import { Networks, AdWordsKeywordTypes } from 'AdsUI/lib/Constants';
import KeywordCreationRecord from 'AdsUI/records/ad-management/KeywordCreationRecord';
export default ((state = AdCreationRecord(), action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Actions.LEAD_AD_CREATION_STATE_SET:
      {
        return payload.state;
      }

    case Actions.LEAD_AD_CREATION_RESET:
      {
        return AdCreationRecord(payload);
      }

    case Actions.LEAD_AD_CREATION_UPDATE:
      {
        return state.merge(payload);
      }

    case Actions.LEAD_AD_CREATION_UPDATE_AD_ACCOUNT:
      {
        return state.withMutations(newState => newState.setIn(['adAccountId'], payload).setIn(['campaignId'], null).setIn(['targeting', 'savedAudience'], null).setIn(['targeting', 'filterGroups'], List()));
      }

    case Actions.LEAD_AD_CREATION_CREATE_NEW_CREATIVE:
      {
        return state.updateIn(['creatives'], creatives => creatives.push(new CREATIVE_RECORD_BY_TYPE[payload.type]()));
      }

    case Actions.LEAD_AD_CREATION_UPDATE_CREATIVE:
      {
        const {
          index,
          updatedCreative
        } = payload;
        return state.mergeIn(['creatives', index], updatedCreative);
      }

    case Actions.LEAD_AD_CREATION_UPDATE_FORM:
      {
        const {
          form
        } = payload;
        return state.set('form', form).mergeIn(['targeting'], {
          estimatedSize: null,
          locale: form ? form.networkLocale : state.targeting.locale
        }).setIn(['automation'], new LeadAdAutomateRecord());
      }

    case Actions.LEAD_AD_CREATION_UPDATE_TARGETING:
      {
        if (payload.dsaInfo) {
          return state.mergeIn(['targeting'], Object.assign({}, payload));
        }

        return state.mergeIn(['targeting'], Object.assign({}, payload, {
          estimatedSize: null
        }));
      }

    case Actions.LEAD_AD_CREATION_UPDATE_OFFSITE_ENABLED:
      {
        return state.setIn(['offsiteDeliveryEnabled'], payload);
      }

    case Actions.LEAD_AD_CREATION_UPDATE_SCHEDULE:
      {
        return state.mergeIn(['schedule'], payload);
      }

    case Actions.LEAD_AD_CREATION_UPDATE_BUDGET:
      {
        return state.mergeIn(['budget'], payload);
      }

    case Actions.LEAD_AD_CREATION_UPDATE_STRATEGY:
      {
        return state.mergeIn(['biddingStrategyInfo'], payload);
      }

    case Actions.LEAD_AD_CREATION_UPDATE_PORTFOLIO_STRATEGY:
      {
        return state.mergeIn(['biddingStrategyInfo', 'portfolioStrategy'], payload);
      }

    case Actions.LEAD_AD_CREATION_UPDATE_AUTOMATION:
      {
        return state.mergeIn(['automation'], payload);
      }

    case Actions.LEAD_AD_CREATION_UPDATE_WEBSITE_URL:
      {
        return state.mergeIn(['creatives', payload.index, 'websiteUrl'], payload.updatedWebsiteUrl);
      }

    case Actions.LEAD_AD_CREATION_UPDATE_KEYWORD:
      {
        return state.mergeIn(['keywords', payload.id], Object.assign({}, payload.updatedKeyword, {
          suggested: false
        }));
      }

    case Actions.LEAD_AD_CREATION_DELETE_KEYWORD:
      {
        return state.deleteIn(['keywords', payload.id]);
      }

    case Actions.LEAD_AD_CREATION_ADD_KEYWORD:
      {
        return state.setIn(['keywords', payload.id], KeywordCreationRecord({
          id: payload.id,
          keywordText: '',
          negative: payload.negative,
          matchType: AdWordsKeywordTypes.PHRASE
        }));
      }

    case Actions.LEAD_AD_NOTIFICATION_EMAILS_FETCH_SUCCEEDED:
      {
        // If there are already notification emails associated with the form in question,
        // we should make sure that they're not deleted
        if (!payload) {
          return state;
        }

        const {
          response,
          id,
          network
        } = payload;
        const {
          form
        } = state;

        if (network === Networks.FACEBOOK && form && id === form.formId) {
          return state.mergeIn(['automation', 'notificationEmails'], response);
        } else {
          return state;
        }
      }

    case Actions.VIDEO_UPLOAD_STATUS_FETCH_SUCCEEDED:
      {
        const {
          creativeIndex,
          mediaUploadStatus
        } = payload || {};
        return state.setIn(['creatives', creativeIndex, 'mediaUploadStatus'], mediaUploadStatus);
      }

    case Actions.ESTIMATED_SIZE_FETCH_SUCCEEDED:
      {
        return state.setIn(['targeting', 'estimatedSize'], payload);
      }

    case Actions.ADWORDS_SUGGESTIONS_FETCH_SUCCEEDED:
      {
        if (!payload || state.getIn(['creatives', payload.creativeIndex, 'modified'])) {
          return state;
        }

        const {
          creativeIndex,
          keywords
        } = payload,
              suggestedCreative = _objectWithoutPropertiesLoose(payload, ["creativeIndex", "keywords"]);

        if (creativeIndex > 0) {
          return state.mergeIn(['creatives', creativeIndex], suggestedCreative);
        }

        return state.mergeIn(['creatives', creativeIndex], suggestedCreative).updateIn(['keywords'], oldKeywords => oldKeywords.filter(keyword => !keyword.suggested && !!keyword.keywordText).merge(keywords));
      }

    case Actions.PORTFOLIO_STRATEGIES_FETCH_SUCCEEDED:
      if (payload) {
        return state.set('portfolioBiddingStrategyOptions', payload.map(option => {
          return {
            text: option.name,
            value: option.id
          };
        }));
      } else return state;

    case Actions.LINKEDIN_AUDIENCE_FACET_FETCH_SUCCEEDED:
      {
        const {
          audienceId,
          adTargetingFacetType
        } = payload || {};
        return state.updateIn(['targeting', 'excludedAudiences'], excludedAudiences => excludedAudiences && excludedAudiences.map(audience => audience.id === audienceId ? audience.set('linkedInAdTargetingFacet', adTargetingFacetType) : audience)).updateIn(['targeting', 'filterGroups'], filterGroups => filterGroups && filterGroups.map(group => group.updateIn(['audiences'], audiences => audiences && audiences.map(audience => audience.id === audienceId ? audience.set('linkedInAdTargetingFacet', adTargetingFacetType) : audience))));
      }

    default:
      {
        return state;
      }
  }
});